import { IExportColumnModel } from '../../../../shared/models/export.column.model'
export const DatabaseEngineColumnList: IExportColumnModel[] = [
]